function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgLogo02 = function SvgLogo02(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 128,
    height: 124.56,
    viewBox: "0 0 128 124.56",
    ref: svgRef
  }, props), React.createElement("path", {
    "data-name": "Rectangle 910",
    style: {
      fill: "none"
    },
    d: "M0 0h128v124.559H0z"
  }), React.createElement("path", {
    "data-name": "Path 934",
    d: "M4 345.689h5.385a2.211 2.211 0 0 0 1.615-.607 2 2 0 0 0 .621-1.49 2.049 2.049 0 0 0-.621-1.5 2.185 2.185 0 0 0-1.615-.621H4zm0-7.563h4.833a2.157 2.157 0 0 0 1.615-.635 2.166 2.166 0 0 0 0-3.036 2.158 2.158 0 0 0-1.615-.635H4zm-4 11.29v-19.322h8.971a6.351 6.351 0 0 1 4.389 1.477 4.734 4.734 0 0 1 1.656 3.685 5.1 5.1 0 0 1-.621 2.471 5.019 5.019 0 0 1-1.67 1.836 5.022 5.022 0 0 1 2.346 1.946 5.1 5.1 0 0 1 .773 2.719 4.746 4.746 0 0 1-1.67 3.713 6.569 6.569 0 0 1-4.513 1.477z",
    transform: "translate(0 -230.653)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 935",
    d: "M62.647 356.688a4.7 4.7 0 0 0 2.774-.911 2.636 2.636 0 0 0 1.284-2.18h-3.423a3.324 3.324 0 0 0-1.946.483 1.294 1.294 0 0 0-.566 1.311q.165 1.3 1.877 1.3m-.331 3.257a8.084 8.084 0 0 1-1.753-.193 7.088 7.088 0 0 1-1.78-.676 3.611 3.611 0 0 1-1.463-1.463 4.675 4.675 0 0 1-.552-2.332 3.864 3.864 0 0 1 1.56-3.423 7.3 7.3 0 0 1 4.209-1.076h4.168v-.69q0-1.849-2.843-1.849-2.429 0-2.953 1.518l-3.809.055a4.226 4.226 0 0 1 1.932-3.588 7.957 7.957 0 0 1 4.748-1.38 8.245 8.245 0 0 1 4.72 1.339 4.008 4.008 0 0 1 1.988 3.436v10.1h-3.783v-1.408a4.635 4.635 0 0 1-1.753 1.145 6.867 6.867 0 0 1-2.636.483",
    transform: "translate(-39.667 -240.961)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 936",
    d: "M118.051 346.022a3.716 3.716 0 0 0 2.733-1.173 3.782 3.782 0 0 0 1.16-2.746 3.839 3.839 0 0 0-1.146-2.774 3.8 3.8 0 0 0-5.507.014 3.829 3.829 0 0 0-1.16 2.76 3.984 3.984 0 0 0 3.92 3.92m.386 3.616a5.939 5.939 0 0 1-4.03-1.435v1.215h-4V330.1h4v5.962a5.918 5.918 0 0 1 4.03-1.518 6.727 6.727 0 0 1 5.148 2.167 7.979 7.979 0 0 1 .027 10.724 6.772 6.772 0 0 1-5.175 2.208",
    transform: "translate(-77.146 -230.654)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 937",
    d: "m172.708 345.671-3.616 9.854-3.809-9.854h-4.251l6.017 14.546-2.318 5.88h4.14l8.087-20.426z",
    transform: "translate(-112.521 -241.537)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 938",
    d: "M221.116 349.416v-19.322h14.271v3.837h-10.13v3.947h9.026v3.722h-9.026v7.811z",
    transform: "translate(-154.505 -230.653)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 939",
    d: "M277.659 356.688a4.7 4.7 0 0 0 2.774-.911 2.636 2.636 0 0 0 1.283-2.18h-3.422a3.322 3.322 0 0 0-1.946.483 1.294 1.294 0 0 0-.566 1.311q.166 1.3 1.877 1.3m-.331 3.257a8.089 8.089 0 0 1-1.753-.193 7.1 7.1 0 0 1-1.78-.676 3.612 3.612 0 0 1-1.463-1.463 4.674 4.674 0 0 1-.552-2.332 3.864 3.864 0 0 1 1.56-3.423 7.3 7.3 0 0 1 4.21-1.076h4.168v-.69q0-1.849-2.843-1.849-2.429 0-2.953 1.518l-3.809.055a4.227 4.227 0 0 1 1.932-3.588 7.957 7.957 0 0 1 4.748-1.38 8.246 8.246 0 0 1 4.72 1.339 4.009 4.009 0 0 1 1.987 3.436v10.1h-3.782v-1.408a4.633 4.633 0 0 1-1.753 1.145 6.868 6.868 0 0 1-2.636.483",
    transform: "translate(-189.906 -240.961)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 940",
    d: "M330.436 359.946a7.549 7.549 0 0 1 0-15.1 7.151 7.151 0 0 1 4.224 1.325 7.432 7.432 0 0 1 2.7 3.478l-3.644 1.049a3.85 3.85 0 0 0-1.311-1.642 3.311 3.311 0 0 0-1.974-.621 3.553 3.553 0 0 0-2.705 1.187 3.96 3.96 0 0 0-1.1 2.788 3.911 3.911 0 0 0 1.1 2.774 3.571 3.571 0 0 0 2.705 1.173 3.3 3.3 0 0 0 1.988-.621 3.932 3.932 0 0 0 1.3-1.615l3.644 1.049a7.478 7.478 0 0 1-2.691 3.45 7.131 7.131 0 0 1-4.237 1.325",
    transform: "translate(-225.627 -240.961)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 941",
    d: "M378.744 350.864h7.094a3.531 3.531 0 0 0-1.269-1.766 3.618 3.618 0 0 0-2.264-.718 3.676 3.676 0 0 0-2.277.718 3.505 3.505 0 0 0-1.284 1.766m3.589 9.082a7.223 7.223 0 0 1-5.341-2.222 7.532 7.532 0 0 1 10.089-11.165 7.458 7.458 0 0 1 2.622 4.306 6.776 6.776 0 0 1 .028 3.037h-10.987a3.153 3.153 0 0 0 1.3 1.863 4.011 4.011 0 0 0 2.291.649 4.9 4.9 0 0 0 3.45-1.242l3.478.994a6.286 6.286 0 0 1-2.843 2.747 8.742 8.742 0 0 1-4.085 1.035",
    transform: "translate(-261.89 -240.961)",
    style: {
      fill: "#ff9484"
    }
  }), React.createElement("path", {
    "data-name": "Path 942",
    d: "M72.031 52.991v14.238h-6.5c-3.7 0-9.9 0-14.017-4.113a13.215 13.215 0 0 1-4.217-9.85 13.879 13.879 0 0 1 3.355-9.683A11.864 11.864 0 0 1 59.613 40a12.585 12.585 0 0 1 8.9 3.13c2.334 2.224 3.517 5.54 3.517 9.858m17.284-.7V31.73c0-4.461 1.283-8.181 3.708-10.759a12.339 12.339 0 0 1 9.27-3.687c3.931 0 7.178 1.26 9.39 3.647 2.348 2.533 3.589 6.273 3.589 10.814v35.484H89.315zm35.047-43.106A29.593 29.593 0 0 0 102.294 0C86.849 0 75.137 10.352 72.563 25.382a31.847 31.847 0 0 0-12.95-2.663 29.116 29.116 0 0 0-21.376 8.845 31.172 31.172 0 0 0-8.223 21.7 30.275 30.275 0 0 0 9.279 22.072c9.175 9.176 21.133 9.176 26.239 9.176h67.025V31.745c0-8.975-2.834-16.777-8.2-22.563",
    transform: "translate(-20.973 .001)",
    style: {
      fill: "#ff9484"
    }
  }));
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/LOGO02.4b3e31fd.svg";
export { ForwardRef as ReactComponent };